<!-- Vehicle Upload Images Modal -->
<div class="modal fade" id="kt_modal_vh_manager_upload_images" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-xl">
    <div class="modal-content">
      <!-- Modal Header -->
      <div class="modal-header d-flex justify-content-between align-items-center">
        <h2 class="fw-bold mb-0">Upload Vehicle Images</h2>
        <div class="btn btn-icon btn-sm btn-active-icon-primary" data-bs-dismiss="modal">
          <i class="ki-duotone ki-cross fs-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
        </div>
      </div>

      <!-- Modal Body -->
      <div class="modal-body">
        <!-- Vehicle Info -->
        <div class="mb-5" *ngIf="selectedVehicle">
          <div class="d-flex align-items-center">
            <div class="symbol symbol-50px me-3">
              <div class="symbol-label rounded bg-light-primary">
                <i class="ki-duotone ki-car fs-2x text-primary">
                  <span class="path1"></span>
                  <span class="path2"></span>
                </i>
              </div>
            </div>
            <div>
              <h5 class="mb-1">{{ selectedVehicle.company_name }} {{ selectedVehicle.name }}</h5>
              <p class="text-muted mb-0">{{ selectedVehicle.year }} • {{ selectedVehicle.car_no }}</p>
            </div>
          </div>
        </div>

        <!-- Upload Progress -->
        <div *ngIf="uploadingImages" class="mb-5">
          <div class="d-flex justify-content-between align-items-center mb-2">
            <span class="text-muted">Uploading images...</span>
            <span class="badge badge-light-primary">{{ uploadProgress.current }} / {{ uploadProgress.total }}</span>
          </div>
          <div class="progress">
            <div class="progress-bar bg-primary"
                 [style.width.%]="(uploadProgress.current / uploadProgress.total) * 100">
            </div>
          </div>
        </div>

        <!-- Existing Images Grid -->
        <div *ngIf="hasVehicleImages()" class="mb-5">
          <h6 class="fw-bold mb-3">Current Images</h6>
          <div class="row g-3">
            <div class="col-md-3" *ngFor="let image of selectedVehicle.pictures; let i = index">
              <div class="card border border-gray-300 position-relative">
                <div class="card-body p-2">
                  <div class="image-container position-relative">
                    <img [src]="image"
                         class="img-fluid rounded"
                         style="width: 100%; height: 120px; object-fit: cover;"
                         alt="Vehicle Image">
                    <button type="button"
                            class="btn btn-icon btn-sm btn-danger position-absolute top-0 end-0 m-1"
                            (click)="removeImage(i)"
                            title="Remove Image">
                      <i class="ki-duotone ki-cross fs-3">
                        <span class="path1"></span>
                        <span class="path2"></span>
                      </i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Upload New Images Section -->
        <div class="mb-5">
          <h6 class="fw-bold mb-3">Upload New Images</h6>

          <!-- Selected Images Preview -->
          <div *ngIf="selectedImages.length > 0" class="mb-4">
            <div class="row g-3">
              <div class="col-md-3" *ngFor="let image of selectedImages; let i = index">
                <div class="card border border-gray-300">
                  <div class="card-body p-2">
                    <div class="image-container">
                      <img [src]="getFilePreviewUrl(image)"
                           class="img-fluid rounded"
                           style="width: 100%; height: 120px; object-fit: cover;"
                           alt="Selected Image">
                      <div class="mt-2">
                        <small class="text-muted">{{ image.name }}</small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Upload Card -->
          <div class="card border-dashed border-2 border-gray-300 rounded p-6 text-center"
               (click)="triggerMultiImageUpload()"
               style="cursor: pointer; min-height: 200px; display: flex; align-items: center; justify-content: center;">
            <div>
              <i class="ki-duotone ki-file-up text-primary fs-3x mb-3">
                <span class="path1"></span>
                <span class="path2"></span>
              </i>
              <h3 class="fs-5 fw-bold text-gray-900 mb-1">Drop files here or click to upload</h3>
              <span class="fs-7 fw-semibold text-gray-500">Upload multiple vehicle images</span>
              <div class="mt-3">
                <span class="badge badge-light-info">JPG, PNG, GIF up to 10MB each</span>
              </div>
            </div>
          </div>

          <!-- Hidden file input -->
          <input type="file"
                 #multiImageInput
                 multiple
                 accept="image/*"
                 (change)="onMultiImageSelected($event)"
                 style="display: none;">
        </div>
      </div>

      <!-- Modal Footer -->
      <div class="modal-footer">
        <button type="button" class="btn btn-light" data-bs-dismiss="modal">Cancel</button>
        <button type="button"
                class="btn btn-primary d-flex align-items-center justify-content-center"
                style="min-width: 150px;"
                (click)="uploadImages()"
                [disabled]="uploadingImages || selectedImages.length === 0">
          <span *ngIf="uploadingImages" class="indicator-progress d-flex align-items-center">
            <span class="spinner-border spinner-border-sm me-2"></span>
            Please wait...
          </span>
          <span *ngIf="!uploadingImages" class="d-flex align-items-center">
            <i class="ki-duotone ki-cloud-add fs-2 me-2">
              <span class="path1"></span>
              <span class="path2"></span>
            </i>
            Upload Images
          </span>
        </button>
      </div>
    </div>
  </div>
</div>
